module.exports = "/packs/media/images/university2-fa23e72b4724acce4f874a3389352fc4.jpg";